import React from 'react';
import { Box, Text } from '@myob/myob-widgets';

import styles from './MinYearlyTotal.common.module.scss';

type MinYearlyTotalViewProps = {
  minTotalPrice: string;
  currency: string;
  gstLabel: string;
  labelText?: string;
  className?: string;
}

export const MinYearlyTotalView: React.FC<MinYearlyTotalViewProps> = ({
  minTotalPrice,
  currency,
  gstLabel,
  labelText = 'Minimum yearly total',
  className
}) => (
  <Box
    className={[styles.minYearlyTotal, className].filter(Boolean).join(' ')}
    data-testid='min-yearly-total'
    display='flex'
    justifyContent='space-between'
    alignItems='center'
  >
    <Box className={styles.minYearlyTotalLabelGroup} display='inline-flex'>
      <Text
        className={styles.minYearlyTotalLabelStrong}
        as='span'
        marginBottom='clear'
        tone='neutralStrongest'
      >
        {labelText}
      </Text>
      <Text
        className={styles.minYearlyTotalLabelGst}
        as='span'
        marginBottom='clear'
        tone='neutralStrongest'
      >
        {gstLabel}
      </Text>
    </Box>
    <Text
      className={styles.minYearlyTotalPrice}
      as='span'
      marginBottom='clear'
      tone='neutralStrongest'
    >
      ${minTotalPrice} {currency}
    </Text>
  </Box>
);
